// Language
const hasClassLangJa = $('body').hasClass('ja')
const hasClassLangEn = $('body').hasClass('en')
// Site
const hasClassTysons = $('body').hasClass('s-Tysons')

// TYSONS Home
export const tysonsHome = hasClassTysons && $('body').hasClass('p-Home')
// TYSONS Recruit
const hasClassRecruitHome = $('body').hasClass('p-recruit--home')
export const tysonsRecruitJa = hasClassTysons && hasClassLangJa && hasClassRecruitHome
export const tysonsRecruitEn = hasClassTysons && hasClassLangEn && hasClassRecruitHome
export const tysonsRecruit = tysonsRecruitJa || tysonsRecruitEn
// TYSONS Recruit Form
const hasClassRecruitForm = $('body').hasClass('p-recruit--form')
export const tysonsRecruitFormJa = hasClassTysons && hasClassLangJa && hasClassRecruitForm
export const tysonsRecruitFormEn = hasClassTysons && hasClassLangEn && hasClassRecruitForm
export const tysonsRecruitForm = tysonsRecruitFormJa || tysonsRecruitFormEn
// TYSONS Recruit Interview
const hasClassRecruitInterview = $('body').hasClass('p-recruit--interview')
export const tysonsRecruitInterviewJa = hasClassTysons && hasClassLangJa && hasClassRecruitInterview
export const tysonsRecruitInterviewEn = hasClassTysons && hasClassLangEn && hasClassRecruitInterview
export const tysonsRecruitInterview = tysonsRecruitInterviewJa || tysonsRecruitInterviewEn
// TYSONS Business
export const tysonsBusiness = $('body').hasClass('s-Tysons p-business')
export const tysonsBusinessJa = $('body').hasClass('s-Tysons p-business ja')
export const tysonsBusinessEn = $('body').hasClass('s-Tysons p-business en')
// TYSONS Join
// export const tysonsJoin = $('body').hasClass('s-Tysons p-join')

// 全体アクセスページ
export const accessPage = $('body').hasClass('p-access')

// Lilycakes Order
export const lilycakesOrder = $('body').hasClass('s-Lilycakes p-order')
export const lilycakesOrderJa = $('body').hasClass('s-Lilycakes p-order ja')
export const lilycakesOrderEn = $('body').hasClass('s-Lilycakes p-order en')



// WEBPACK FOOTER //
// ./src/js/constants/page.js